import { render, staticRenderFns } from "./VehicleExpiryReminders.vue?vue&type=template&id=2a9dd2a7&scoped=true"
import script from "./VehicleExpiryReminders.vue?vue&type=script&lang=js"
export * from "./VehicleExpiryReminders.vue?vue&type=script&lang=js"
import style0 from "./VehicleExpiryReminders.vue?vue&type=style&index=0&id=2a9dd2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9dd2a7",
  null
  
)

export default component.exports